import { BrowserRouter, Routes, Route } from "react-router"
import Home from "../components/home"
import LoginForm from "../components/loginForm"
import { AuthGuard } from "../authentication/authGuard"
import { AuthProvider } from "../authentication/authContext"

export const AppRouter = () => {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={
                        <AuthGuard>
                            <Home />
                        </AuthGuard>
                    } />
                    <Route path="/login" element={<LoginForm />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    )

}
